















































import { dataTypes } from './data'
import FormModal from './FormModal.vue'
import { cloneDeep } from 'lodash'
import { IotAppPropertyServiceProxy } from '@/service-proxies/app-v2/iot-console.service-proxies'

const apsp = new IotAppPropertyServiceProxy()

const add = apsp.addIotAppProperty.bind(apsp)
const edit = apsp.updateIotAppProperty.bind(apsp)
const getAddrList = apsp.getIoAddressList.bind(apsp)
export default FormModal.extend({
  name: 'AttributeEditOrAdd',
  props: ['app', 'gatewayCode', 'type', 'editData'],
  data() {
    return {
      dataTypes,
      addrList: [],
      form: {
        addressParam: undefined,
        // appCode: 0,
        defaultValue: undefined,
        description: undefined,
        factor: 1,
        // gatewayCode: undefined,
        ioAddressPrefix: undefined,
        name: undefined,
        type: undefined
      }
    }
  },
  computed: {
    dataTypeList() {
      let temp = []
      let keys = Object.keys(this.dataTypes)
      keys.map(k => {
        temp.push({ label: this.dataTypes[k], value: String(k) })
      })
      return temp
    },
    rules() {
      return {
        name: [{ required: true, message: this.$t('page_getwat_list_enter_property_name'), trigger: 'blur' }, {
          validator: this.validateName,
          trigger: 'blur'
        }],
        ioAddressPrefix: [{ required: true, message: this.$t('page_getwat_list_address_parameters'), trigger: 'blur' }],
        type: [{ required: true, message: this.$t('page_getwat_list_select_data_type'), trigger: 'blur' }],
        factor: [{ required: true, message: this.$t('page_getwat_list_enter_magnification'), trigger: 'blur' }]
      }
    }
  },
  watch: {
    editData: {
      handler(val) {
        Object.keys(this.form).map(k => {
          this.form[k] = undefined
          if (k === 'factor') {
            this.form[k] = 1
          }
        })
        if (JSON.stringify(val) !== '{}') {
          this.form = cloneDeep(val)
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 校验属性名称
    validateName(rule, value, callback) {
      const reg = /^\w+$/
      if (value === '') {
        callback(new Error(this.$t('page_my_document_entername')))
      } else if (!reg.test(value)) {
        callback(new Error(this.$t('page_getwat_list_only_contain_English')))
      } else {
        // this.form.name = this.form.name.toLowerCase()
        callback()
      }
    },
    async initialData() {
      const { items } = await getAddrList(this.app.code, this.gatewayCode)
      this.addrList = items
    },
    changeAddr(val: string) {
      let { returnType } = this.addrList.find(addr => addr.name === val)
      if (returnType && typeof returnType === 'string') {
        this.form.type = returnType
      }
    },
    changeDataType(val: string) {
      this.form = Object.assign({}, this.form, { type: val })
    },
    async handleSubmit() {
      this.loading = true
      let params = {
        appCode: this.app.code,
        gatewayCode: this.gatewayCode
        // isTakeEffected: !!(this.form.isTakeEffected)
      }
      params = Object.assign({}, this.form, params)
      try {
        if (this.type === 'add') {
          await add(params)
        } else {
          await edit(params)
        }
        this.$message.success(this.$t('page_resource_pool_success'))
        this.loading = false
        this.trigger()
        this.$emit('reload')
      } catch (e) {
        console.log(e)
      }
    }
  }
})
